import { render, staticRenderFns } from "./ReviewsDetails.vue?vue&type=template&id=52544898&scoped=true"
import script from "./ReviewsDetails.vue?vue&type=script&lang=js"
export * from "./ReviewsDetails.vue?vue&type=script&lang=js"
import style0 from "./ReviewsDetails.vue?vue&type=style&index=0&id=52544898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52544898",
  null
  
)

export default component.exports